(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fv-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  "use strict";
  const root = document;
  const prefersReducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Reveal on scroll (fade + slide up) ---------- */
  function initReveal() {
    const els = root.querySelectorAll(".fv-home [data-reveal]");
    if (!els.length) return;
    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          obs.unobserve(el);
          if (prefersReducedMotion()) {
            el.style.opacity = 1;
            return;
          }
          el.animate(
            [
              { opacity: 0, transform: "translateY(32px)" },
              { opacity: 1, transform: "translateY(0)" },
            ],
            { duration: 800, easing: "cubic-bezier(.16,1,.3,1)", fill: "forwards" }
          );
        });
      },
      { rootMargin: "0px 0px -12% 0px", threshold: 0 }
    );
    els.forEach((el) => {
      el.style.opacity = 0;
      io.observe(el);
    });
  }

  /* ---------- Reveal phone mockup image (fade + slide + blur) ---------- */
  function initRevealPhone() {
    const els = root.querySelectorAll(".fv-home [data-reveal-phone]");
    if (!els.length) return;
    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          obs.unobserve(el);
          if (prefersReducedMotion()) {
            el.style.opacity = 1;
            return;
          }
          el.animate(
            [
              { opacity: 0, transform: "translateY(18px)", filter: "blur(6px)" },
              { opacity: 1, transform: "translateY(0)", filter: "blur(0px)" },
            ],
            { duration: 700, easing: "cubic-bezier(.16,1,.3,1)", fill: "forwards" }
          );
        });
      },
      { rootMargin: "0px 0px -16% 0px", threshold: 0 }
    );
    els.forEach((el) => {
      el.style.opacity = 0;
      io.observe(el);
    });
  }

  /* ---------- Typewriter rotator ---------- */
  function wait(ms) {
    return new Promise((r) => setTimeout(r, ms));
  }
  function tweenText(el, from, to, duration) {
    return new Promise((resolve) => {
      const start = performance.now();
      function frame(now) {
        const p = Math.min(1, (now - start) / duration);
        const n = from + (to - from) * p;
        el.textContent = el.dataset.typewriterBase.slice(0, Math.round(n));
        if (p < 1) requestAnimationFrame(frame);
        else resolve();
      }
      requestAnimationFrame(frame);
    });
  }
  async function runTypewriter(el, phrases) {
    let i = 0;
    el.dataset.typewriterBase = phrases[0];
    el.textContent = phrases[0];
    while (el.isConnected) {
      await wait(1200);
      const current = phrases[i];
      el.dataset.typewriterBase = current;
      await tweenText(el, current.length, 0, Math.max(580, current.length * 32));
      await wait(260);
      i = (i + 1) % phrases.length;
      const next = phrases[i];
      el.dataset.typewriterBase = next;
      await tweenText(el, 0, next.length, Math.max(900, next.length * 58));
    }
  }
  function revealHeroLead(typewriterEl) {
    return new Promise((resolve) => {
      const lead = typewriterEl.closest(".bloque_hero-lead, .bloque_hero_intermedio-lead");
      if (!lead) return resolve();
      lead.animate(
        [
          { opacity: 0, filter: "blur(8px)" },
          { opacity: 1, filter: "blur(0px)" },
        ],
        { duration: 500, easing: "cubic-bezier(.16,1,.3,1)", fill: "forwards" }
      ).onfinish = resolve;
    });
  }
  function revealHeroButton(heroSection, afterLead) {
    const button = heroSection && heroSection.querySelector(".bloque_hero-button, .bloque_hero_intermedio-button");
    if (!button) return;
    afterLead.then(() =>
      wait(140).then(() => {
        button.animate(
          [
            { opacity: 0, transform: "translateY(8px)" },
            { opacity: 1, transform: "translateY(0)" },
          ],
          { duration: 480, easing: "cubic-bezier(.16,1,.3,1)", fill: "forwards" }
        );
      })
    );
  }
  function initTypewriter() {
    const els = root.querySelectorAll(".fv-home [data-typewriter]");
    if (!els.length) return;
    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          obs.unobserve(el);
          const heroSection = el.closest(".bloque_hero, .bloque_hero_intermedio");
          if (prefersReducedMotion()) {
            const lead = el.closest(".bloque_hero-lead, .bloque_hero_intermedio-lead");
            if (lead) lead.style.opacity = 1;
            const button = heroSection && heroSection.querySelector(".bloque_hero-button, .bloque_hero_intermedio-button");
            if (button) {
              button.style.opacity = 1;
              button.style.transform = "none";
            }
            return;
          }
          const phrases = (el.dataset.typewriterPhrases || "")
            .split("|")
            .map((s) => s.trim())
            .filter(Boolean);
          wait(120).then(() => {
            const leadDone = revealHeroLead(el);
            revealHeroButton(heroSection, leadDone);
            if (phrases.length) runTypewriter(el, phrases);
          });
        });
      },
      { rootMargin: "0px 0px -12% 0px", threshold: 0 }
    );
    els.forEach((el) => io.observe(el));
  }

  /* ---------- Cintas: responsive marquee duration ---------- */
  function initCintasDuration() {
    const animEls = root.querySelectorAll(".fv-home .bloque_cintas-marquee-animate");
    if (!animEls.length) return;
    const isMobile = () => window.matchMedia("(max-width: 480px)").matches;
    const update = () => {
      const reduced = prefersReducedMotion();
      animEls.forEach((el) => {
        if (reduced) {
          el.setAttribute("dur", "999s");
          return;
        }
        const dur = isMobile() ? el.dataset.mobileDuration : el.dataset.desktopDuration;
        if (dur) el.setAttribute("dur", dur);
      });
    };
    update();
    window.addEventListener("resize", update);
  }

  /* ---------- Cursos: lightweight carousel (no external library) ---------- */
  function initCursosCarousel() {
    root.querySelectorAll(".fv-home .bloque_cursos").forEach((block) => {
      const viewport = block.querySelector(".bloque_cursos-swiper");
      const track = viewport && viewport.querySelector(".swiper-wrapper");
      const slides = track ? Array.from(track.children) : [];
      if (!viewport || !track || !slides.length) return;

      const prevBtn = block.querySelector(".bloque_cursos-arrow-prev");
      const nextBtn = block.querySelector(".bloque_cursos-arrow-next");
      let index = 0;
      let maxIndex = 0;
      let dragEnabled = true;
      let dragging = false;
      let startX = 0;
      let deltaX = 0;
      let baseTranslate = 0;

      function getConfig() {
        const w = window.innerWidth;
        if (w >= 1920) return { perView: 2, gap: 32, drag: false };
        if (w >= 992) return { perView: 2.2, gap: 32, drag: false };
        return { perView: 1, gap: 24, drag: true };
      }

      function render(animate) {
        track.style.transition = animate ? "transform .45s cubic-bezier(.22,1,.36,1)" : "none";
        const cfg = getConfig();
        const slideWidth = slides[0].getBoundingClientRect().width;
        const step = slideWidth + cfg.gap;
        track.style.transform = "translateX(" + -(index * step) + "px)";
        if (prevBtn) {
          prevBtn.disabled = index <= 0;
          prevBtn.classList.toggle("swiper-button-disabled", index <= 0);
        }
        if (nextBtn) {
          nextBtn.disabled = index >= maxIndex;
          nextBtn.classList.toggle("swiper-button-disabled", index >= maxIndex);
        }
      }

      function layout() {
        const cfg = getConfig();
        dragEnabled = cfg.drag;
        const containerWidth = viewport.clientWidth;
        const slideWidth = (containerWidth - cfg.gap * (cfg.perView - 1)) / cfg.perView;
        slides.forEach((slide) => {
          slide.style.flex = "0 0 " + slideWidth + "px";
          slide.style.width = slideWidth + "px";
          slide.style.marginRight = cfg.gap + "px";
        });
        maxIndex = Math.max(0, slides.length - Math.ceil(cfg.perView));
        index = Math.min(index, maxIndex);
        render(false);
      }

      if (prevBtn) {
        prevBtn.addEventListener("click", () => {
          index = Math.max(0, index - 1);
          render(true);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener("click", () => {
          index = Math.min(maxIndex, index + 1);
          render(true);
        });
      }

      track.style.display = "flex";
      track.addEventListener("pointerdown", (e) => {
        if (!dragEnabled) return;
        dragging = true;
        startX = e.clientX;
        deltaX = 0;
        const slideWidth = slides[0].getBoundingClientRect().width;
        const cfg = getConfig();
        baseTranslate = -index * (slideWidth + cfg.gap);
        track.style.transition = "none";
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      });
      track.addEventListener("pointermove", (e) => {
        if (!dragging) return;
        deltaX = e.clientX - startX;
        track.style.transform = "translateX(" + (baseTranslate + deltaX) + "px)";
      });
      const endDrag = () => {
        if (!dragging) return;
        dragging = false;
        const slideWidth = slides[0].getBoundingClientRect().width;
        const threshold = slideWidth * 0.2;
        if (deltaX < -threshold) index = Math.min(maxIndex, index + 1);
        else if (deltaX > threshold) index = Math.max(0, index - 1);
        deltaX = 0;
        render(true);
      };
      track.addEventListener("pointerup", endDrag);
      track.addEventListener("pointercancel", endDrag);
      track.addEventListener("pointerleave", () => {
        if (dragging) endDrag();
      });

      window.addEventListener("resize", layout);
      layout();
    });
  }

  /* ---------- Galeria logos: 3D coverflow carousel ---------- */
  const CF_OPACITY_STEP = 0.16;
  const CF_VISIBLE_RANGE = 2;
  const CF_TRANSLATE_Z = 240;
  const CF_TRANSLATE_X_UNIT = 8;
  const CF_ROTATE_Y = 12;
  const CF_ROTATE_Z = 8;
  const CF_DIM_OPACITY = 0.4;
  const CF_LOCK_MS = 600;
  const CF_AUTOPLAY_MS = 2500;

  function circularDelta(index, center, total) {
    let d = index - center;
    if (d > total / 2) d -= total;
    if (d < -total / 2) d += total;
    return d;
  }

  function applyCoverflow(items, center) {
    const total = items.length;
    items.forEach((item, i) => {
      const delta = circularDelta(i, center, total);
      const abs = Math.abs(delta);
      const visible = abs <= CF_VISIBLE_RANGE;
      const scale = Math.max(0.4, 1 - abs * CF_OPACITY_STEP);
      const tx = delta * CF_TRANSLATE_X_UNIT * 30;
      const tz = -abs * CF_TRANSLATE_Z;
      const rotY = -delta * CF_ROTATE_Y;
      const rotZ = delta * CF_ROTATE_Z;
      item.style.opacity = visible ? "1" : "0";
      item.style.pointerEvents = visible ? "auto" : "none";
      item.style.transform =
        "translate(-50%, -50%) translateX(" + tx + "px) translateZ(" + tz + "px) rotateY(" + rotY + "deg) rotateZ(" + rotZ + "deg) scale(" + scale + ")";
      item.style.setProperty("--coverflow-dim-opacity", delta === 0 ? "0" : String(CF_DIM_OPACITY));
      item.setAttribute("aria-hidden", visible ? "false" : "true");
    });
  }

  function initCoverflowGallery(container) {
    const items = Array.from(container.querySelectorAll("[data-coverflow-item]"));
    if (!items.length) return;
    let center = 0;
    let locked = false;
    const autoplay = container.dataset.autoplay === "true";
    const dir = container.dataset.autoplayDirection === "leftToRight" ? -1 : 1;
    const reduced = prefersReducedMotion();

    const lock = () => {
      locked = true;
      window.setTimeout(() => (locked = false), CF_LOCK_MS);
    };
    const advance = (step) => {
      if (locked || items.length < 2) return;
      lock();
      center = ((center + step) % items.length + items.length) % items.length;
      applyCoverflow(items, center);
    };
    const goTo = (index) => {
      if (autoplay || locked || index === center) return;
      lock();
      center = index;
      applyCoverflow(items, center);
    };

    items.forEach((item, i) => item.addEventListener("click", () => goTo(i)));
    container.addEventListener("keydown", (e) => {
      if (e.key === "ArrowRight") {
        e.preventDefault();
        advance(1);
      } else if (e.key === "ArrowLeft") {
        e.preventDefault();
        advance(-1);
      }
    });

    applyCoverflow(items, center);
    if (autoplay && !reduced) window.setInterval(() => advance(dir), CF_AUTOPLAY_MS);
  }

  function initGaleriaLogos() {
    root.querySelectorAll(".fv-home [data-coverflow-gallery]").forEach(initCoverflowGallery);
  }

  /* ---------- Smooth in-page anchor scroll ---------- */
  function initAnchorScroll() {
    root.querySelectorAll(".fv-home a[href^='#']").forEach((a) => {
      const id = a.getAttribute("href").slice(1);
      if (!id) return;
      const target = root.getElementById(id);
      if (!target) return;
      a.addEventListener("click", (e) => {
        e.preventDefault();
        target.scrollIntoView({ behavior: prefersReducedMotion() ? "auto" : "smooth", block: "start" });
      });
    });
  }

  function boot() {
    initReveal();
    initRevealPhone();
    initTypewriter();
    initCintasDuration();
    initCursosCarousel();
    initGaleriaLogos();
    initAnchorScroll();
  }

  if (root.readyState === "loading") root.addEventListener("DOMContentLoaded", boot);
  else boot();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
  $(document).ready(function() {
    $.fn.digits = function() {
      return this.each(function() {
        $(this).text( $(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") );
      })
    };
    update_mini_cart();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notificaciones"]) return;
  try {
    
  document.querySelector(".cerrar-noti").addEventListener("click", (e) => {
    document.querySelectorAll(".noti").forEach(box => { box.style.display = "none" })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-state"]) return;
  try {
    
  // iFrameResize({log: true});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              var observer = lozad(); // lazy loads elements with default selector as '.lozad'
              observer.observe();
              quantity_elements(true);
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
